module.exports = __webpack_public_path__ + "img/ximalaya.ca0b253b.webp";